/**
 * UnifiedBetCard.jsx — thin shell (god-file decomposition).
 *
 * Logic lives in ../hooks/useUnifiedBetCard (state, effects, memo, handlers,
 * derived values). Rendering lives in ./UnifiedBetCardView. This file just
 * wires the two together so callers are unaffected.
 *
 * Styles: ./unifiedBetCardStyles. Math: ../utils/canonicalEv.
 * Display helpers: ../utils/betCardFormatters (shared with BetCardV2).
 */

import React from 'react';
import { useUnifiedBetCard } from '../hooks/useUnifiedBetCard';
import UnifiedBetCardView from './UnifiedBetCardView';

const UnifiedBetCard = (props) => {
    const merged = useUnifiedBetCard(props);
    return <UnifiedBetCardView {...merged} />;
};

export default UnifiedBetCard;
